import { useEffect, useRef, useState } from "react";

// Renders `children` (the formatted price) and flashes green/red for ~600 ms whenever `value` ticks up/down.
export const FlashPrice = ({ value, children, className = "", tid }) => {
  const prev = useRef(value);
  const [dir, setDir] = useState(null);
  const [key, setKey] = useState(0);
  useEffect(() => {
    if (value == null || prev.current == null || value === prev.current) { prev.current = value ?? prev.current; return undefined; }
    setDir(value > prev.current ? "up" : "down"); setKey((k) => k + 1);
    prev.current = value;
    const id = setTimeout(() => setDir(null), 650);
    return () => clearTimeout(id);
  }, [value]);
  return (
    <span key={key} className={`apx-flash ${dir ? `apx-flash-${dir}` : ""} ${className}`} data-testid={tid} data-flash={dir || "none"}>
      {children}
    </span>
  );
};
